import session from "../../../services/session";
import swal from "sweetalert2";
import AdminApi from '../../../services/api'
import CONFIG_COMPANY from "../../../services/myConfig";
import Loc from "../../../services/localization";
import UTILS from "../../../services/utils";

const AdminApiService = new AdminApi();
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            selectedImage: null,
            selectedImagePreview: null,
            imageUrl: null,
            idToEdit: null,
            allCustomCategories: [],
            selectedCustomCategories: [],
            model: {
                orderNumber: 0,
                name: '',
                enName: '',
                shortDescription: '',
                enShortDescription: '',
                longDescription: '',
                enLongDescription: '',
                imageHeader: null,
                imageMain: '',
                type: 'TRAINER',
                locations: null
            },

        }
    },
    methods: {
        addTraining: addTraining,
        editTraining: editTraining,
        getTrainingInfoById: getTrainingInfoById,
        editTrainingFromApi: editTrainingFromApi,
        loadTextFromFile: loadTextFromFile,
        reset: reset,
        isSelected: isSelected,
        getChipClass: getChipClass,
        clickSelectCustomCategory: clickSelectCustomCategory,
        addTrainingFromApi: addTrainingFromApi,
        uploadPhoto: uploadPhoto,
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.allCustomCategories = session.getConfig().customCategories.split(";");
        this.idToEdit = this.$route.query.id;
        if(this.idToEdit != null){
            this.getTrainingInfoById()
        }
    }
}

function getTrainingInfoById(){
    let _self = this;
    AdminApiService.getCompanyInfoById(this.idToEdit)
        .then((response) => {
            _self.imageUrl = response.data.imageMain
            _self.model.name = response.data.name
            _self.model.enName = response.data.enName
            _self.model.orderNumber = response.data.orderNumber
            _self.model.shortDescription = response.data.shortDescription
            _self.model.enShortDescription = response.data.enShortDescription
            _self.model.longDescription = response.data.longDescription
            _self.model.enLongDescription = response.data.enLongDescription
            _self.model.imageMain = response.data.imageMain
            _self.selectedCustomCategories = response.data.locations == null ? [] : response.data.locations.split(";").filter(e => e.length > 0)
        })
        .catch((error) => {
            swal(LocService.t('label_error'), LocService.t('label_image_upload_error'), 'error')
        })
}

function addTraining() {
    if(this.idToEdit != null){
        this.editTraining();
        return;
    }
    let _self = this;
    if (_self.model.name === '' || _self.model.shortDescription === '' || _self.selectedImage == null) {
        swal(LocService.t("label_error"), LocService.t('label_ci_training_required'), 'error')
        return;
    }
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {
    });

    _self.uploadPhoto(false);

}

function editTraining(){
    let _self = this;
    if (_self.model.name === '' || _self.model.shortDescription === '' ) {
        swal(LocService.t("label_error"), LocService.t('label_ci_training_required'), 'error')
        return;
    }
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {
    });
    if(_self.selectedImage != null){
        _self.uploadPhoto(true)
    }else{
        _self.editTrainingFromApi(_self.model.imageMain)
    }
}

function uploadPhoto(isEdit) {
    let _self = this;
    AdminApiService.uploadImageCompanyInfo(this.selectedImage)
        .then((response) => {
            if(isEdit){
                _self.editTrainingFromApi(response.data.url)
            }else{
                _self.addTrainingFromApi(response.data.url);
            }

        })
        .catch((error) => {
            swal(LocService.t('label_error'), LocService.t('label_image_upload_error'), 'error')
        })
}

function editTrainingFromApi(url) {
    let _self = this;
    let modelToSend = {
        id: this.idToEdit,
        name: this.model.name,
        enName: this.model.enName,
        orderNumber: this.model.orderNumber <= 0 ? null : this.model.orderNumber,
        shortDescription: this.model.shortDescription,
        enShortDescription: this.model.enShortDescription,
        longDescription: this.model.longDescription,
        enLongDescription: this.model.enLongDescription,
        imageHeader: null,
        imageMain: url,
        type: 'TRAINER',
        locations: UTILS.formatSelectedLocations(_self.selectedCustomCategories)
    }
    AdminApiService.updateCompanyInfoTraining(modelToSend)
        .then((response) => {
            _self.reset();
            swal(LocService.t("label_success"), LocService.t('label_ci_training_success_add'), 'success')
            _self.$router.push(CONFIG_COMPANY.HOME + "?selectedButton=TRAINER");
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function addTrainingFromApi(url) {
    let _self = this;
    let modelToSend = {
        name: this.model.name,
        enName: this.model.enName,
        orderNumber: this.model.orderNumber <= 0 ? null : this.model.orderNumber,
        shortDescription: this.model.shortDescription,
        enShortDescription: this.model.enShortDescription,
        longDescription: this.model.longDescription,
        enLongDescription: this.model.enLongDescription,
        imageHeader: null,
        imageMain: url,
        type: 'TRAINER',
        locations: UTILS.formatSelectedLocations(_self.selectedCustomCategories)
    }
    AdminApiService.addCompanyInfoTraining(modelToSend)
        .then((response) => {
            _self.reset();
            swal(LocService.t("label_success"), LocService.t('label_ci_training_success_add'), 'success')
            _self.$router.push(CONFIG_COMPANY.HOME + "?selectedButton=TRAINER");
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function reset() {
    this.selectedImage = null
    this.selectedImagePreview = null
    this.imageUrl = null
    this.model = {
        name: '',
        enName: '',
        shortDescription: '',
        enShortDescription: '',
        longDescription: '',
        enLongDescription: '',
        imageHeader: null,
        imageMain: '',
        type: 'TRAINER',
        locations: null
    }
}


function loadTextFromFile(ev) {
    var i = 0;
    for (i = 0; i < ev.target.files.length; i++) {
        const file = ev.target.files[i];
        if (file.size > 5000000) {
            alert(this.locale.t('label_max_size_picture'))
            return
        }
        const reader = new FileReader();
        this.selectedImage = file;
        this.selectedImagePreview = URL.createObjectURL(file);
        reader.onload = e => {
            // console.log(e.target.result);
            // _self.files.push(e.target.result);
        }

        reader.readAsDataURL(file);

    }

}


function getChipClass(item) {
    if (this.selectedCustomCategories.includes(item)) {
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelected(item) {
    return this.selectedCustomCategories.includes(item)
}

function clickSelectCustomCategory(item) {
    if (this.selectedCustomCategories.includes(item)) {
        this.selectedCustomCategories = this.selectedCustomCategories.filter(e => e !== item)
    } else {
        this.selectedCustomCategories.push(item)
        if(this.selectedCustomCategories.length === this.allCustomCategories.length){
            this.selectedCustomCategories = []
        }
    }
}




// WEBPACK FOOTER //
// ./src/components/Home/Add/AddTrainerInfo.js